import { StylesConfig } from "react-select";
import { LangE } from "../../models/enums";

// custom styling of the select category dropdown list for the OrderBy component
export const customSortSelectStyles = (lang: string): StylesConfig<any, false> => ({
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? '#333333' : '#ffffff',
        color: state.isSelected ? '#ffffff !important' : '#000000',
        whiteSpace: 'nowrap',
        fontSize: '0.87rem',
        lineHeight: '1.31rem',
        height: 29,
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        '&:hover': {
            color: '#34A7F0'
        },
        direction: lang === LangE.EN ? 'ltr' : 'rtl',
    }),
    control: (provided, state) => ({
        ...provided,
        width: 'fit-content',
        height: 41,
        background: '#fff',
        borderRadius: 25,
        border: 'none',
        boxShadow: 'none',
        cursor: 'pointer',
        "&:hover": {
            outline: 'none',
            boxShadow: 'none',
        },
        "&:active": {
            outline: 'none',
            boxShadow: 'none'
        },
        "&:focus": {
            outline: 'none',
            boxShadow: 'none'
        }
    }),
    indicatorSeparator: () => ({}),
    valueContainer: (provided) => ({
        ...provided,
        padding: 0,
        paddingInlineStart: 20,
        overflow: 'none',
        fontFamily: lang === LangE.EN ? 'Roboto' : 'Rubik',
        fontSize: '.87rem',
        lineHeight: '1.31rem',
        direction: lang === LangE.EN ? 'ltr' : 'rtl',
    }),
    singleValue: (provided, state) => ({
        ...provided,
        color: '#34A7F0',
        '&:hover': {
            color: '#248ACB'
        }
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        padding: 8,
        paddingInlineEnd: 13,
    }),
    menu: (provided) => ({
        ...provided,
        width: 'fit-content',
        boxShadow: '0px 4px 9px rgba(116, 116, 116, 0.25)',
        borderRadius: 5,
        direction: lang === LangE.EN ? 'ltr' : 'rtl',
    }),
});